import { createSelector } from 'reselect'
import { RootState } from 'types'

// Custom selector
const selectAuthenticationView = (state: RootState) => state.authenticationView

const selectUserEntities = (state: RootState) => state.userEntities.entities

export const selectCurrentUserId = (state: RootState) => selectAuthenticationView(state).userId

export const selectCurrentUser = createSelector(
  selectUserEntities,
  selectCurrentUserId,
  (userEntities, userId) => (userId ? userEntities[userId] : undefined)
)

export const selectIsLoggedIn = (state: RootState) => selectAuthenticationView(state).isLoggedIn

export const selectBusinessId = (state: RootState) => selectAuthenticationView(state).businessId

/**
 * Business role for the current business: 'owner' | 'admin' | 'member' | 'viewer'.
 * Undefined when there's no scoped business (PENDING_BUSINESS_ID) or the legacy
 * tokens (pre-`brole` claim) are still in flight. Read this for UI gating only;
 * server enforces all access decisions.
 */
export const selectCurrentBusinessRole = (state: RootState) =>
  selectAuthenticationView(state).businessRole

/**
 * True until the boot-time silent refresh has resolved one way or the other.
 * Auth-gated layouts must wait on this before redirecting to /login, otherwise the
 * user briefly sees the login page on every reload (silent refresh wins moments
 * later, but the navigation already happened).
 */
export const selectIsHydrating = (state: RootState) => selectAuthenticationView(state).isHydrating
